import SBookMark from "@public/image/icon/bookmark.svg";
import { useState } from "react";

import { PostIndexProps } from "./PostIndex";
import PostIndexList from "./PostIndexList";

function PostIndexMobile({ indexList }: PostIndexProps) {
  const [isOpen, setOpen] = useState<boolean>(false);

  const togglePostIndex = () => {
    if (isOpen) document.body.style.overflow = "auto";
    else document.body.style.overflow = "hidden";

    setOpen((prev) => !prev);
  };

  const MOBILE_BACKGROUND_CN = `${isOpen ? "block" : "hidden"}`;
  const MOBILE_CONTAINER_CN = `${isOpen ? "max-h-[50%] max-w-[60%]" : "max-h-[52px] max-w-[52px]"}`;
  const MOBILE_CONTENT_CN = `${isOpen ? "" : "h-5 w-5 overflow-hidden"}`;
  const MOBILE_ICON_CN = `${isOpen ? "hidden " : "block opacity-100 delay-100"}`;
  const MOBILE_UL_CN = `${isOpen ? "opacity-100 delay-100" : "opacity-0"}`;

  return (
    <>
      <div
        className={`fixed left-0 top-0 z-[90] h-screen w-screen bg-black/10 backdrop-blur-sm post:hidden ${MOBILE_BACKGROUND_CN}`}
        onClick={togglePostIndex}
      ></div>
      <button
        className={`fixed bottom-5 left-5 z-[100] overflow-y-auto rounded-md bg-white p-4 shadow-md transition-[max-height,max-width] duration-700 post:hidden ${MOBILE_CONTAINER_CN}`}
        onClick={togglePostIndex}
        aria-label="블로그 목차 토글"
      >
        <div className={`${MOBILE_CONTENT_CN}`}>
          <div className={`flex items-center justify-center duration-700`}>
            <SBookMark width={20} height={20} className={`fill-black ${MOBILE_ICON_CN}`} aria-label="북마크" />
          </div>
          <ul className={`flex flex-col gap-3 transition-all duration-700 ${MOBILE_UL_CN}`}>
            <PostIndexList indexList={indexList} />
          </ul>
        </div>
      </button>
    </>
  );
}

export default PostIndexMobile;
